// @ts-nocheck
import { ReportOrderFrequencyModel } from "@store/Framework/Services/Reporting/ReportingModels";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { reportOrderFrequencySelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencySelectors";
import { useSelector } from "react-redux";

const useOrderFrequencyState = () => {
    const orderFrequency = useSelector(reportOrderFrequencySelector);
    const dispatch = useBunzlDispatch();
    const setOrderFrequency = (orderFrequency: ReportOrderFrequencyModel) => {
        dispatch({
            type: "Store/Pages/ReportOrderFrequency/CompleteLoadReportOrderFrequency",
            report: orderFrequency,
        });
    };
    return [orderFrequency, setOrderFrequency] as const;
};
export default useOrderFrequencyState;
